import { axios } from "~/plugins/request"
export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  selectInformationPackage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('informationPackage/selectInformationPackage', params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
	getCredentials({commit}, params) {
	  return new Promise((resolve, reject) => {
		axios.post('informationPackage/getCredentials', params)
	    .then(response => {
	      resolve(response)
	    }).catch(error => {
	      reject(error)
	    })
	  })
	},
  upload({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/informationPackage/uploadFile',
        method: 'post',
        data: params,
        headers: {'Content-Type': 'multipart/form-data'}
      }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  informationPackageSave({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`informationPackage/informationPackageSave`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteInformationPackage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`informationPackage/deleteInformationPackage`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
